<template>
  <v-flex xs12 class="text-xs-center" v-if="$store.state.vehicles.loadingVehicles">
    <v-progress-circular indeterminate :color="$store.state.global.pages[$route.name].color"></v-progress-circular>
  </v-flex>
  <transition name="fadeToggle" mode="out-in" v-else>
    <v-flex xs12 v-if="listView">
      <v-card hover>
        <v-data-table
          :items="filteredVehicles"
          :headers="headers"
          :rows-per-page-items="itemsPerPageOptions"
        >
          <template slot="items" slot-scope="props">
            <table-row :headers="headers" :row="props.item" parent="Vehicle" :key="props.item.id"></table-row>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <transition-group v-else name="data-list" tag="layout-no-padding">
      <v-flex
        xs12
        sm6
        md4
        xl3
        v-for="(vehicle,i) in filteredVehicles.slice(0, 16)"
        :key="vehicle.id"
        class="data-list-item"
      >
        <vehicle-card :vehicle="vehicle" :index="i"></vehicle-card>
      </v-flex>
    </transition-group>
  </transition>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import VehicleService from '@/services/requests/vehicleService'
import VehicleCard from '@/components/vehicles/vehicleCard'
import TableRow from '@/components/ui/masterFileTableRow'
export default {
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'name',
        },
        {
          text: 'Type',
          align: 'left',
          value: 'vehicleType.name',
        },
        {
          text: 'Tonnage',
          align: 'right',
          value: 'vehicleType.tonnage',
        },
        {
          text: 'Contractor',
          align: 'right',
          value: 'contractor.name',
        },
        {
          text: 'Compliance Resources',
          align: 'right',
          value: 'complianceCount',
        },
        {
          text: 'Actions',
          align: 'center',
          sortable: false,
        },
      ],
    }
  },
  computed: {
    sortBy: Store.getSet({ store: 'vehicles', prop: 'sortBy' }),
    filterBy: Store.getSet({ store: 'vehicles', prop: 'filterBy' }),
    vehicles: Store.getSet({ store: 'vehicles', prop: 'vehicles' }),
    listView: Store.getSet({ store: 'vehicles', prop: 'listView' }),
    contractor: Store.getSet({ store: 'vehicles', prop: 'contractor' }),
    showInactive: Store.getSet({ store: 'vehicles', prop: 'showInactive' }),
    selectedRecordType: Store.getSet({
      store: 'vehicles',
      prop: 'selectedRecordType',
    }),
    contractorFilteredSites() {
      if (!!this.contractor) {
        return this.vehicles.filter((vehicle) => {
          return vehicle.contractorId == this.contractor
        })
      } else {
        return this.vehicles
      }
    },
    sortedVehicles() {
      if (this.sortBy) {
        var path = this.sortBy
        return this.contractorFilteredSites.sort((a, b) => {
          if (this.getObjectPath(path, a) < this.getObjectPath(path, b)) {
            if (path == 'updatedAt') {
              return 1
            }
            return -1
          } else {
            if (path == 'updatedAt') {
              return -1
            }
            return 1
          }
        })
      } else {
        return this.contractorFilteredSites
      }
    },
    filteredVehicles() {
      return this.sortedVehicles.filter((vehicle) => {
        const nameSearchMatch =
          vehicle.name.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1
        const vinSearchMatch = !!vehicle.vin
          ? vehicle.vin.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1
          : null
        if (this.selectedRecordType === 'Inactive')
          return (
            (nameSearchMatch || vinSearchMatch) &&
            (!vehicle.active || !vehicle.contractor.active)
          )
        else if (this.selectedRecordType === 'Request')
          return (nameSearchMatch || vinSearchMatch) && vehicle.request
        else
          return (
            (nameSearchMatch || vinSearchMatch) &&
            vehicle.active &&
            vehicle.contractor.active &&
            !vehicle.request
          )
      })
    },
  },
  components: {
    VehicleCard,
    TableRow,
  },
}
</script>

<style scoped>
</style>
